import Annotator from './Annotator';

export default Annotator;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/index.js